import { CUSTOMER_ACCOUNTING } from 'config/actionTypes'
import moment from 'moment'
import { setManuelInvoice } from 'firebase/database/mauellAccountingHandler'
const { CONFIG } = CUSTOMER_ACCOUNTING


const INIT_STATE = {
    config : {
        appType: '',
        accountingRecipientType: '',
        accountingType: '',
        taskType: '',
        recipientType: '',
        selectedMember: null,
    },
    recipient: {
        id: '',
        name: '',
        street: '',
        postCode:'',
        city: '',
        memberNr:''
    },
    services: [],
}
function customAccountingReducer(state = INIT_STATE, action) {
    
    switch(action.type) {
        case CONFIG.SET_ACCOUNTING_RECIPIENT_TYPE : {	
			return ({
				...state,
                config: {...state.config, accountingRecipientType: action.payload}
			})
		}
        case CONFIG.SET_ACCOUNTING_TYPE : {	
			return ({
				...state,
                config: {...state.config, accountingType: action.payload}
			})
		}
        case CONFIG.SET_TASK_TYPE : {	
			return ({
				...state,
                config: {...state.config, taskType: action.payload }
			})
		}
        case CONFIG.SET_RECIPIENT_TYPE : {	
			return ({
				...state,
                config: {...state.config, recipientType: action.payload}
			})
		}
        case CUSTOMER_ACCOUNTING.SET_RECIPIENT : {
            return({
                ...state,
                recipient: action.payload
            })
        }
        case CONFIG.SET_SELECTED_MEMBER : {
            return({
                ...state,
                config: {
                    ...state.config,
                    selectedMember: action.payload
                }
                
            })
        }
        case CUSTOMER_ACCOUNTING.ADD_SERVICE : {
            return({
                ...state,
                services: [...state.services, action.payload]
            })
        }
        case CUSTOMER_ACCOUNTING.DEL_SERVICE : {
            const _services = [...state.services]
            _services.splice(action.payload, 1)
            return({
                ...state,
                services: [..._services]
            })
        }
        case CUSTOMER_ACCOUNTING.RESET_ALL : {
            return {...INIT_STATE}
        }
        case CUSTOMER_ACCOUNTING.SEND_ACCOUNTING : {
            const { recipient, services } = state
         
            const { username, id } = action.payload
            const mInvoice = {
                editor: {
                    id,
                    name: username,
                    timeStamp: moment().format(),
                },
                recipient,
                services

            }
            setManuelInvoice(mInvoice)
            return state
        }
        
        default : return state;
    }
}
    
    export default customAccountingReducer;